export const TEST_ID = 'footerNote';

// Locked copy per FAA drawer v2 spec (section 2.6, Footer note).
export const NOTE_TEXT = 'Always confirm advisories with current NOTAMs and TFRs before flight.';

// Info-"i" circle SVG geometry — 16×16 viewBox, 1.5px stroke.
// Matches prototype drawer.jsx footer-note SVG.
export const ICON_SIZE = 16;

export const ICON_STROKE_WIDTH = 1.5;

export const ICON_CIRCLE_CENTER = 8;

export const ICON_CIRCLE_RADIUS = 6.5;

export const ICON_STEM_X = 8;

export const ICON_STEM_Y_START = 7;

export const ICON_STEM_Y_END = 11.5;

export const ICON_DOT_X = 8;

export const ICON_DOT_Y = 4.5;

export const ICON_DOT_RADIUS = 0.9;
